<template>
  <section
    class="add_new_head white--body bg--blue tx--bege relative cover m_bg_blue no_mobile"
    style="background-image:url('/assets/img/layout/bg_serg.jpg');"
  >
    <div class="popup_close close-animate no-print">
      <a @click.prevent="$emit('goBackRoute')"><CloseSvg /></a>
    </div>
    <a
      v-if="!isInfo"
      class="no_mobile link_goback no-print"
      @click="$emit('approveGoBack')"
    >
      חזרה <ArrowBackSvg />
    </a>
    <div class="inner_width flex flex--column center">
      <h1 v-if="isInfo" class="title">
        <span class="bold">
          פרטי ניתוח
        </span>
        {{ activeDoctor.name }}
      </h1>
      <h1 v-else class="title">
        <span class="bold">סיכום פרטי ניתוח </span>{{ activeDoctor.name }}
      </h1>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import ArrowBackSvg from "@/assets/img/svg/arrow_r.svg";
import CloseSvg from "@/assets/img/svg/close.svg";

export default {
  name: "ApproveDesktopHeader",
  props: ["isInfo"],
  components: {
    ArrowBackSvg,
    CloseSvg
  },
  computed: {
    ...mapGetters(["activeDoctor"])
  }
};
</script>
